import script from "./mealsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./mealsDetails.vue?vue&type=script&setup=true&lang=js"

import "./mealsDetails.vue?vue&type=style&index=0&id=41b7d214&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41b7d214"]])

export default __exports__